import React, { useState } from 'react';
import './ReferralCode.css';
import { useTranslation } from 'react-i18next';

function ReferralCode() {
  const [copied, setCopied] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const referral_code = urlParams.get("r");
  const { t } = useTranslation();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referral_code);
      setCopied(true);
      // Reset the "Copied" state after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <>
      {referral_code && (
        <div className="referral-container">
          <div>
         {t('referral_code')}:
          </div>
          <div className='title'>
            {referral_code}
          </div>
          <div className='copy' onClick={handleCopy}>
            {copied ? (
              // Checkmark icon for success feedback
              <>
                <svg className='copied' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                </svg>
                <span className='copied'>{t('copied')}</span>
              </>
            ) : (
              // Copy icon
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
              </svg>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ReferralCode;
